import { FC } from 'react';
import { SimpleGrid, VStack } from '@chakra-ui/react';
import { useFormContext, useWatch } from 'react-hook-form';
import { RadioBox } from '../radioBox';
import { DonationField } from '../../constants';
import { getDataTracking } from '../../utils';

export interface DonationAmountsProps {
  levels: string[];
  onChange: () => void;
  donationAmount: number;
}

export const DonationAmounts: FC<DonationAmountsProps> = ({
  levels,
  onChange,
  donationAmount,
}): JSX.Element => {
  const { setValue, trigger } = useFormContext();
  const donationAmountValue =
    useWatch({ name: DonationField.donationAmount }) || donationAmount;

  return (
    <VStack align="left" spacing={2} w="full">
      <SimpleGrid columns={[2, 3]} spacing={2} w="full">
        {levels.map((level, index) => {
          const value = parseInt(level);
          return (
            <RadioBox
              {...getDataTracking(level)}
              id={`option${index + 1}`}
              data-testid={`${Number(level)}donationAmount`}
              isActive={donationAmountValue === value}
              fontSize={24}
              key={level}
              onClick={() => {
                setValue(DonationField.donationAmount, value);
                setValue(DonationField.donationOtherAmount, '');
                trigger(DonationField.donationAmount);
                onChange();
              }}
              py={6}
            >
              ${level}
            </RadioBox>
          );
        })}
      </SimpleGrid>
    </VStack>
  );
};
